<template>
  <div>
    <Row>
      <Form ref="queryWebSiteForm" :model="query" :label-width="70"  label-position="right" inline class="index-query-form">
        <Form-item :label="this.$t('cms.website.name.label')" prop="name">
            <Input v-model="query.name" :placeholder="$t('cms.website.name.holder')" style="width: 200px" />
        </Form-item>
        <Form-item :label="this.$t('cms.website.status.label')" prop="status">
        <Select v-model="query.status" clearable filterable :placeholder="$t('cms.website.status.holder')">
          <Option v-for="item in $t('cms.website.status.dictionary')" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        </Form-item>
        <Form-item :label-width="0">
            <span @click="handleSearch" style="margin: 0 10px;"><Button type="primary" >{{$t('searchText')}}</Button></span>
            <Button @click="resetSearchForm" type="default" >{{$t('resetText')}}</Button>
        </Form-item>
        <Button @click="openWebSiteDrawer()" type="primary" style="margin-right: 10px;float:right" >{{$t('newText')}}</Button>
      </Form>
    </Row>
    <Row v-loading="page.loading" class="margin-top-10  searchable-table-con1"  style="width:100%;">
      <Table ref="webSiteTable" :columns="columns" stripe border :data="page.data" @on-sort-change="handlePageSortChange"></Table>
      <Row v-if="page.total>0" type="flex" justify="space-between" align="middle" >
        <div>
          <Select v-model="batchOperate.action" placeholder="请选择" style="width:120px;margin-right: 10px;">
            <Option v-for="item in batchOperate.options" :key="item.value" :label="item.label" :value="item.value"></Option>
          </Select>
          <Button type="primary" :disabled="this.batchOperate.action=='' || $refs.webSiteTable.getSelection().length == 0" :loading="batchOperate.submiting" @click="handleBatchOperate">{{ batchOperate.submiting ? '提交中 ...' : '确 定' }}</Button>
        </div>
        <Page :current="page.current" :total="page.total"  :page-size="page.size" @on-change="handlePageChange" show-elevator show-total style="padding: 10px;"></Page>
      </Row>
    </Row>
    <el-drawer ref="webSiteDrawer" :title="this.$t('drawer.title')[webSiteDrawer.type]" :visible.sync="webSiteDrawer.visible" direction="rtl" size="40%" custom-class="right-drawer">
      <div class="right-drawer__content">
        <webSite-form ref="webSiteForm"/>
        <div class="right-drawer__footer" v-if="webSiteDrawer.type!='detail'">
          <Button type="primary" @click="handleSubmit()" :loading="webSiteDrawer.submiting">{{ webSiteDrawer.submiting ? '提交中 ...' : '保 存' }}</Button>
          <Button @click="webSiteDrawer.visible=false">取 消</Button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script type="text/jsx">
import Vue from 'vue';

import api from '@/api'
import mixin from '@/libs/mixins/Index'

import WebSiteForm from '@/views/cms/web-site/components/Form.vue';
Vue.component('webSite-form', WebSiteForm);

export default {
  name: 'aip-cms-webSite-index',
  mixins:[mixin],
  data () {
    return {
      query:{
          name:''
      },
      page:{
         size: 10,
         current: 1,
         total: 0,
         sort: "id_desc",
         loading:false,
         data:[]
      },
      webSiteDrawer:{
        action:'add',
        visible: false,
        submiting:false
      },
      batchOperate:{
        action:'',
        submiting:false,
        options:[
          {value:'handleBatchRemove',label:'批量删除'}
        ]
      }
    }
  },
  methods: {
    handleSearch(){
      this.page.loading = true;
      api.cms.WebSite.query(this.query,this.page)
        .then(data=>{
            this.page =  Object.assign(this.page,data);
            this.page.loading = false;
        }).catch(error=> this.page.loading = false)
    },
    openWebSiteDrawer(webSite){
      this.webSiteDrawer.visible = true
      this.webSiteDrawer.type = webSite ? webSite.type : 'add'
      this.$nextTick(()=>{
          if(webSite){
              this.$refs['webSiteForm'].getWebSite(webSite.id,webSite.type)
          }else{
            this.$refs['webSiteForm'].handleReset()
          }
      })
    },
    handleSubmit(){
        this.webSiteDrawer.submiting = true;
        this.$refs.webSiteForm.handleSubmit(
          data=>{
            this.webSiteDrawer.submiting = false;
            this.handleSearch();
            setTimeout(() => this.webSiteDrawer.visible=false, 1000);
          },
          ()=>{
            this.webSiteDrawer.submiting = false;
          }
        )
    },
    deleteWebSite(id){
      api.cms.WebSite.remove(id)
                            .then(response=> {
                                this.$Message.success(this.$t('successText'))
                                this.handleSearch()
                            }).catch(error=> console.log(error))
    },
    handleBatchRemove(rows){
      this.batchOperate.submiting = true
      Promise.all(rows.map(item=>api.cms.WebSite.remove(item.id)))
          .then(res => {
            this.batchOperate.submiting = false;
            this.handleSearch()
          }).catch(e=> {
            this.batchOperate.submiting = false
            this.handleSearch()
          })
    }
  },
  computed: {
    columns () {
      return [
          {key: 'id', width: 60, fixed:'left',type:'selection'},

          {key: 'code', align:'',minWidth: 200,fixed:'left', title:  this.$t('cms.website.code.label')},
          {key: 'name', align:'',minWidth: 200, title:  this.$t('cms.website.name.label')},
          {key: 'logoUrl', align:'left',minWidth: 120, title:  this.$t('cms.website.logoUrl.label')},
          {
            key: 'defaultFlag',
            align: 'center',
            width: 120,
            
            title: this.$t('cms.website.defaultFlag.label'),
            
            render: (h, params) => {
              return  <div>
                        <i-switch value={params.row.defaultFlag} onOn-change={(v)=>{api.cms.WebSite.changeDefaultFlag(params.row.id,v).then(e=>this.$Message.success(this.$t('successText')))}}>
                          {
                            this.$t('dictionary.boolean.yesOrNo').map(item => {
                              return <span value={item.value} key={item.value} slot={item.slot}>{ item.label }</span>
                            })
                          }
                        </i-switch>
                      </div>
            }
          },
          {key: 'memo', align:'',minWidth: 200, title:  this.$t('cms.website.memo.label')},
          {
            key: 'status',
            align: 'center',
            width: 120,
            
            column:'status',
            filters: this.$t('cms.website.status.dictionary'),
            filterMultiple: false,
            
            filterRemote:(value,row)=>{
              this.query.status = value
              this.handleSearch();
            },
            title: this.$t('cms.website.status.label'),
            render: (h, params) => {
              return  <div>{params.column.filters.find(t=>params.row.status==t.value).label}</div>
            }
          },
          {key: 'createTime', align: 'center', width:170, title: this.$t('cms.website.createTime.label'),},
          {key: 'updateTime', align: 'center', width:170, title: this.$t('cms.website.updateTime.label'),},
          {key: 'sort', align:'center',minWidth: 90, title:  this.$t('cms.website.sort.label'),sortable: 'custom',column:'sort'},
        {
          title: this.$t('operateText'),
          align: 'center',
          width: 140,
          fixed:"right",
          key: 'handle',
          render: (h, params)=>{
            return <div style="display: flex;justify-content: space-around;">
              <a href="javascript:void(0);" onClick={()=>this.openWebSiteDrawer({ id: params.row.id ,type:'detail'})}>{this.$t('detailText')}</a>
              <a href="javascript:void(0);" onClick={()=>this.openWebSiteDrawer({ id: params.row.id ,type:'edit' })}>{this.$t('editText')}</a>
              <Poptip confirm={true} title={this.$t('deletePopTip')} transfer={true} onOn-ok={()=>this.deleteWebSite(params.row.id)}>
                <a href="javascript:void(0);">{this.$t('deleteText')}</a>
              </Poptip>
            </div>
          }
        }
      ]
    }
  }
}
</script>